import React, { FunctionComponent, useRef } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { bemClassNames, transformKeysToParamCase, useFitText } from "@multiweb/reactUtils";
import { FlagColor } from "@multiweb/types/react";
import { Skeleton } from "../Skeleton";

const { flagToCss } = bridge;

const classNames = bemClassNames("reporting-scalar");

export enum ColorIntensity {
    none = "none",
    default = "default",
    vibrant = "vibrant",
    inverted = "inverted",
}

export type ReportingScalarComponentProps = {

    /** Barva pozadí */
    readonly backgroundColor: FlagColor;
    /** Nadpis  */
    readonly caption?: string;
    /** intenzita barvy */
    readonly colorIntensity: ColorIntensity;
    /** Formulář otevřený při kliku */
    readonly formName?: string;
    /** jestli je interaktivní */
    readonly interactive: boolean;
    /** Hlavní údaj získaný z dotazu */
    readonly value?: string;
    /** Popis */
    readonly description?: string;
    /** Funkce pro otevření formmuláře */
    readonly onClick: () => void;
};

export const ReportingScalarComponent: FunctionComponent<ReportingScalarComponentProps> = ({
    backgroundColor,
    caption,
    value,
    description,
    colorIntensity,
    interactive,
    formName,
    onClick,
}) => {
    const refValue = useRef<HTMLElement>(null);
    const refParent = useRef<HTMLElement>(null);

    const fontSize = useFitText(refValue, refParent, 100, value);

    return (
        <div
            className={classNames(transformKeysToParamCase({ withForm: !!formName, disabled: !interactive }))}
            data-bg-type={colorIntensity}
            data-flag={flagToCss(backgroundColor)}
            onClick={onClick}
        >
            <span className={classNames("caption")} title={caption}>{caption}</span>
            <span className={classNames("description")} title={description}>{description}</span>
            <span ref={refParent} className={classNames("value")}>
                <span ref={refValue} style={{ fontSize }} title={value}>{value ?? <Skeleton height={"50%"} />}</span>
            </span>
        </div>
    );
};
